<template>
    <div class="entity-date-slider js-entity-date-slider-container">
        <div class="js-entity-date-slider entity-date-slider__container swiper-container">
            <div class="message-date-slider__wrapper swiper-wrapper">
                <div class="swiper-slide">
                    {{period}}
                </div>
            </div>
        </div>
        <div class="entity-date-slider__ctrls">
            <button v-on:click="prev"
                    class="entity-date-slider__ctrl--prev slider-ctrl__button button-icon button-icon--th-slider js-date-prev">
                <i class="icon icon--angle-left"></i>
            </button>
            <button v-on:click="next"
                    class="entity-date-slider__ctrl--next slider-ctrl__button button-icon button-icon--th-slider js-date-next">
                <i class="icon icon--angle-right"></i>
            </button>
        </div>
    </div>
</template>

<script type="text/javascript">
    export default {
        name: 'period-slider',
        props: {
            account: Object,
            refreshProductsData: null
        },
        data: function () {
            return {
                month: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
                year: 2022,
                currentMonth: 1,
                period: ''
            }
        },
        methods: {
            setPeriod: function () {
                var m = this.month[this.currentMonth - 1];
                this.period = m + " " + this.year;
                this.refreshProductsData(this.account.BspId, this.account.PersonAccountId, this.year, this.currentMonth);
            },
            next: function () {
                if (
                    (this.year == this.account.MaxYear && this.currentMonth < this.account.MaxMonth)
                    ||
                    (this.year < this.account.MaxYear)
                ) {

                    if (this.currentMonth == 12) {
                        this.year++;
                        this.currentMonth = 1;
                    }
                    else {
                        this.currentMonth++;
                    }
                    this.setPeriod();
                }
            },
            prev: function () {
                if (
                    (this.year == this.account.MinYear && this.currentMonth > this.account.MinMonth)
                    ||
                    (this.year > this.account.MinYear)
                ) {
                    if (this.currentMonth == 1) {
                        this.year--;
                        this.currentMonth = 12;
                    }
                    else {
                        this.currentMonth--;
                    }
                    this.setPeriod();
                }
            }
        },
        mounted() {
            this.currentMonth = this.account.CalcData.CalcMonth;
            this.year = this.account.CalcData.CalcYear;
            this.setPeriod();
            this.$nextTick(function () {
                // Код, который будет запущен только после
                // отрисовки всех представлений
            });
        }
    }
</script>


// WEBPACK FOOTER //
// Scripts/app/fl/components/period-slider.vue